import * as React from "react";
import styled from "styled-components";

import { Metrics } from "../../vars";

class NavbarDropdownLabel extends React.Component<any, any> {
  render() {
    const { className, children } = this.props;
    return (
      <span
        className={className}
        tabIndex={0}
        role="menuItem"
        aria-label={children ? children.toString() : ""}
      >
        {children}
      </span>
    );
  }
}

export default styled(NavbarDropdownLabel)`
  line-height: ${Metrics.LineHeights.NAVBAR_ITEM_TEXT}px;
  font-size: ${Metrics.FontSizes.NAVBAR_ITEM_TEXT}px;
  color: ${p => p.theme.colors.grey500};
  text-decoration: none;
`;
